
import { axios_helper_async } from "helpers/Axios";
import { Response } from "Common/Models/Currency/Response";

export async function GetCurrencyChange(setMessages: (messages: any) => void, setNotifications: (notifications: any) => void) {
    try {
        const response = await axios_helper_async<Response>("/SOI/Get-Exchange-Data", 'GET');
    
        setMessages(response.messages);
        setNotifications(response.notifications);

        if (response.data && response.data.bmx && response.data.bmx.series) {
            const series = response.data.bmx.series[0];
            const exchangeRate = parseFloat(series.datos[0].dato);
            return exchangeRate;
        } else {
            console.error('No se encontró información en la respuesta.');
            return 0;
        }
    } catch (error) {
        console.error('Error al consultar el tipo de cambio:', error);
        return -1;
    }
}